import Immutable from "immutable";
import { Client } from "resourceModels";

export default class SmsPlatformRecord extends Immutable.Record({
  name: "sms",
  fullName: "SMS",
  authId: "",
  authKey: "",
  enabled: true,

  isVisibleToClient(client: Client): boolean {
    return (
      client.hasFullSitePrivileges &&
      !client.features.get("zendeskClient")
    );
  }
}) {}
